
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/intellichecker",
      function () {
        return require("private-next-pages/intellichecker.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/intellichecker"])
      });
    }
  